export const EDIT_BUTTON_TITLE = 'Edit';
